var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var HeaderBusiness = function (storeContainer) {
    var store = storeContainer.store;
    var commonStore = store.commonStore, shareStore = store.shareStore;
    var propsConnect = {
        title: commonStore.title,
        isHideHeader: commonStore.isHideHeader,
        isShowBack: commonStore.isShowBack,
        isShowEmergencyMessage: commonStore.isShowEmergencyMessage,
        emergencyMessageHeight: commonStore.emergencyMessageHeight,
        isHideToggler: commonStore.isHideToggler,
        menuShow: commonStore.menuShow,
        clientCode: commonStore.clientCode,
        clientId: commonStore.clientId,
        currentUser: commonStore.currentUser,
        callCenter: commonStore.callCenter,
        customConfigs: commonStore.customConfigs,
        isShowCopilot: commonStore.isShowCopilot,
        isRedirectRequestRepairToCopilot: commonStore.isRedirectRequestRepairToCopilot,
        isEnableCopilotFeatureToggleSwitcher: commonStore.isEnableCopilotFeatureToggleSwitcher,
    };
    var dispatchConnect = {
        toggleMenu: function () { return commonStore.toggleMenu(); },
        getCurrentUser: function () { return commonStore.getCurrentUser(); },
        hideHeader: function (hideHeader) { return commonStore.hideHeader(hideHeader); },
        showBack: function (isShowEmergencyMessage) {
            return commonStore.showBack(isShowEmergencyMessage);
        },
        showEmergencyMessage: function (isShowBack) {
            return commonStore.showEmergencyMessage(isShowBack);
        },
        setEmergencyMessageHeight: function (height) {
            return commonStore.setEmergencyMessageHeight(height);
        },
        hideToggler: function (isHideToggler) {
            return commonStore.hideToggler(isHideToggler);
        },
        setTitle: function (title) { return commonStore.setTitle(title); },
        getCallCenter: function () { return commonStore.getCallCenter(); },
        logoClickLog: function () { return commonStore.logoClickLog(); },
        getRatingToggle: function () { return commonStore.getRatingToggle(); },
        getCustomConfigs: function () { return commonStore.getCustomConfigs(); },
        getCopilotEnable: function () { return commonStore.getCopilotEnable(); },
        getEnableCopilotFeatureToggleSwitcher: function () { return commonStore.getEnableCopilotFeatureToggleSwitcher(); },
    };
    return __assign(__assign({}, propsConnect), dispatchConnect);
};
